<p-confirmDialog header="Bitte bestätigen:" icon="pi pi-exclamation-triangle" message=".." rejectLabel="Abbrechen">
</p-confirmDialog>

<div class="container-fluid">

  <div class="grid" style="padding-top:0.5rem">
    <div class="col-6">
      <div class="grid">
        <mat-icon class="pageTitleIcon material-icons-outlined">event_available</mat-icon>
        <h2 class="pageTitleHeader">Medientipps</h2>
        @if (!isManager) {
          <i name="newmediatip" class="pi pi-plus pageAddButtonIcon" (click)="newMediatip()"
          pTooltip="Medientipp erstellen"></i>
        }
      </div>
    </div>
    <div class="col-3 ">
      <div class="grid field">
        @if (isManager) {
          <label class="col-12 mb-4 md:col-3 md:mb-0 center-block" for="alle">Alle anzeigen</label>
        }
        <div class="col-12 md:col-6">
          @if (isManager) {
            <p-checkbox id="alle" pTooltip="Eigene oder alle Medientipps anzeigen."
              (onChange)="loadMediatips($event.checked)" [(ngModel)]="allMediatips" binary="true">
            </p-checkbox>
          }
        </div>
      </div>
    </div>
    <div class="col ">
      <div class="grid field">
        <label class="col-12 mb-2 md:col-2 md:mb-0 center-block" for="calendar">Ab:</label>
        <div class="col-12 md:col-6">
          <p-datepicker #filterCalendar class="col" id="calendar" [(ngModel)]="filterfromDate" [firstDayOfWeek]="1"
            dateFormat="dd.mm.yy" (onSelect)="loadMediatipsfromDate(allMediatips, $event)"
            (keyup.enter)="loadMediatipsfromDate(allMediatips, $event)"
            appendTo="body" required
            placeholder="Medientipps ab Datum..." [showButtonBar]="false" [showIcon]="true"
          [disabled]="isLoading$ | async"></p-datepicker>
        </div>
      </div>
    </div>

  </div>
  @if (isLoading$  | async) {
    <div class="flex justify-content-center">
      <p-progressSpinner styleClass="custom-spinner" animationDuration="2s"
      [style]="{width: '3em', height: '3rem'}"></p-progressSpinner>
    </div>
  }

  @if (usePaging()) {
    <p-paginator [rows]="this.pageSorting.rowsToLoad" [totalRecords]="selectmediatipsHits$ | async"
      [showCurrentPageReport]="true" [currentPageReportTemplate]="'{first} bis {last} von {totalRecords} Medientipps'"
      [first]="this.pageSorting.skipRows" [rowsPerPageOptions]="[20,40, 60, 80]"
    (onPageChange)="paginateMediatipps($event)"></p-paginator>
  }

  @for (task of mediatipTasks$ | push ; track trackByMediatip($index, task)) {
    <p-panel [toggleable]="true"
      ><ng-template #headericons let-collapsed><span [class]="collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"></span></ng-template>
      <p-header style="width: 100%;">
        <div class="grid">
          <div class="col-6">
            <h4 style="white-space: nowrap;"> {{task?.name}} </h4>
          </div>
          <div class="col">&ensp;</div>
          @if (canSort(task)) {
            <div class="col-2 grid">
              <label style="margin-right: 1em; margin-top: 0.5rem; float:right; "
              [for]="task.mediatipState.toString() + 'dropdown'"> Sortierung</label>
              <p-select [style]="{'width':'200px'}" [disabled]="isLoading$ | async"
                [id]="task.mediatipState.toString() + 'dropdown'" class="classSortColumns" [ngModel]="GetSortOption(task)"
                [options]="GetSortColumns(task)" optionLabel="caption" (onChange)="loadSort(task, $event)">
                <ng-template style="width: 100%" let-sort pTemplate="item">
                  <div class="ui-helper-clearfix" style="position: relative;height: 25px; width: 150px">
                    <div style="font-size:14px;display: inline-block;margin-top:4px;padding-left: 20px;">
                      {{sort.caption}}
                    </div>
                    <i style="float:right; font-size: 1em; color: var(--colorMenuIcon);"
                    [ngClass]="getSearchIcon(sort)"></i>
                  </div>
                </ng-template>
              </p-select>
            </div>
          }
        </div>
      </p-header>
      @if (task.mediatipState) {
        <p-table [value]="mediatipGroups()[task.mediatipState]" [paginator]="false" width="100%"
          >
          <ng-template pTemplate="header">
            <tr>
              <th [ngClass]="'kb-header-cell-actionandimage'"></th>
              <th [ngClass]="'kb-header-cell-artikel'"> </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td>
                <div class="grid ">
                  <div class=" col-6">
                    <p-buttongroup >
                      @for (btn of mediatipActions()[rowData.id].actions; track btn) {
                        <div>
                          <p-overlay-badge [badgeDisabled]="!getNotification(rowData, btn.label)" badgeSize="small"
                            severity="warn" [value]="getNotification(rowData, btn.label)">
                            <p-button [severity]="btn.severity" size="small"
                              [disabled]="btn.disabled(rowData, btn.label)" (onClick)="btn.action(rowData)" type="button"
                              [pTooltip]="btn.tooltip">
                              <mat-icon [style]=" { 'height': 'calc(var(--fontSizeBigger)*1.0) ', 'width' : 'calc(var(--fontSizeBigger)*1.0)', 'font-size' : 'calc(var(--fontSizeBigger)*1.0)'}" >{{btn.icon}}</mat-icon>
                            </p-button>
                          </p-overlay-badge>
                        </div>
                      }
                    </p-buttongroup>
                  </div>
                  <p-contextMenu [triggerEvent]="'click'" class="contextMenue col-1" appendTo="body" #mediatipMenu
                  [target]="tipActions" [model]="mediatipActions()[rowData.id].menu"></p-contextMenu>
                  <i (click)="toggle($event, mediatipMenu)" #tipActions class="pi pi-ellipsis-h treeTableButton"></i>
                  <div class="col">
                    <img class="bubimage" (click)="openMediatip(rowData)" fetchPriority="low" loading="lazy"
                      [src]='"https://produktbilder.paragon-data.net/" + (rowData.bubData && rowData.bubData.ean ? rowData.bubData.ean : rowData.ean) + "_120x120.jpg?showDummy=true"'>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="grid ">
                    <div class="col-3 artikelClass">{{ rowData.ean }}</div>
                    <div class="col-3 authorClass">{{ rowData.bubData ? rowData.bubData.autor : "" }}
                    </div>
                    <div class="col-3 artikelClass">{{ rowData.bubData ? rowData.bubData.titel : "" }}
                    </div>
                    <div class="col verlagClass ">{{ getVerlag(rowData) }}</div>
                  </div>
                  <div class="grid ">
                    <div class="col-2"> {{ getTitelVersand(rowData)}}</div>
                    @if (isManager) {
                      <div class="col-4">Lieferant</div>
                    }
                    @if (!isManager  || this.allMediatips) {
                      <div class="col-4">Empfänger</div>
                    }
                    <div class="col">&nbsp;</div>
                  </div>
                  <div class="grid ">
                    <div class="col-2">
                      {{ getVersandDatum(rowData) | date:"dd.MM.yyyy" }}
                    </div>
                    @if (isManager) {
                      <div class="col-4">
                        {{ rowData.creatingUserName }}
                      </div>
                    }
                    @if (!isManager  || this.allMediatips) {
                      <div class="col-4">
                        {{ rowData.targetUserName }}
                      </div>
                    }
                    <div class="col">&nbsp;</div>
                  </div>
                  @if (rowData.mediaPresences.length > 0) {
                    <p-panel [toggleable]="false"
                      >
                    @for (item of rowData.mediaPresences ; track item) {
                      <div class="grid ">
                        <div class="col">{{item.presence}}</div>
                        <div class="col">{{item.presenceType}}</div>
                        <div class="col">{{item.presenceDate | date }}</div>
                      </div>
                    }
                  </p-panel>
                }
                @if (rowData.remark) {
                  <p-panel showHeader="false"  >
                    <div class="grid">
                      <div class="col-2">Anmerkung</div>
                      <div class="col">{{rowData.remark}}</div>
                    </div>
                  </p-panel>
                }
              </td>
            </tr>
            <!-- Empty  für eine Line -->
            <tr class="mediaSeperator">
              <td class="mediaSeperator" colspan="2">
                <hr>
                </td>
              </tr>
            </ng-template>
          </p-table>
        }
      </p-panel>
    }




    @if ( (isLoading$  | async) == false &&  viewLoaded == true && this.mediatipList().length == 0) {
      <div class="classMessage alert alert-success"
        >
        Es wurden keine Medientipps gefunden.
      </div>
    }

  </div>
